var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"hit fz-12",class:_vm.getStatusClass(_vm.row, _vm.column)},[_vm._v("\n\t"+_vm._s(_vm.row.activity_status_desc))])])
}
var staticRenderFns = []

export { render, staticRenderFns }